import { Box, ListItemText, Skeleton, Typography, useTheme } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { taskFullLabel, taskLabel } from "routes/schedule/compare/task-label"
import { useCommitFunction } from "routes/schedule/compare/use-commit-function"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Bound } from "lib/@components/binding/Bound"
import { Task } from "routes/schedule/tasks/task"
import { StatusButton } from "routes/schedule/compare/status"
import { useMeasurement } from "lib/@hooks/useMeasurement"
import { Approved } from "routes/schedule/compare/approved"

export function RemovedTask({ task }) {
    const [add, setAdd] = useState(true)
    const remove = !add
    const [{ width, height }, attach] = useMeasurement()
    useCommitFunction(
        (target) => {
            target.tasks.push(task)
        },
        remove,
        [task]
    )
    const [hover, setHover] = useState(false)
    const theme = useTheme()

    return (
        <Bound alwaysOpenTask={true}>
            <PropertyBox spacing={0}>
                <DifferenceWrapper label={`${!add ? "Reinstate" : ""} removed ${taskLabel(task)} "${task.title}"`}>
                    <ListItemBox ml={0.5}>
                        <Box
                            flex={1}
                            position="relative"
                            sx={{ opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear" }}
                            data-cy="task-removed-left-panel"
                        >
                            <ListItemText
                                disableTypography
                                secondary={
                                    <Typography variant="body2">
                                        {remove
                                            ? `${taskLabel(task).titleize()} reinstated`
                                            : `${taskLabel(task).titleize()} removed`}
                                    </Typography>
                                }
                                primary={
                                    remove ? (
                                        <Box>
                                            <Bound editMode={false}>
                                                <Task last={true} item={task} index={0} />
                                            </Bound>
                                        </Box>
                                    ) : (
                                        <Box position="relative">
                                            <Skeleton
                                                variant="rectangular"
                                                width={width || "100%"}
                                                sx={{ minHeight: 110, minWidth: 180 }}
                                                animation={false}
                                                height={height}
                                            />
                                            <Box
                                                position="absolute"
                                                left="50%"
                                                top="50%"
                                                sx={{
                                                    transform: "translate3d(-50%, -50%, 0)",
                                                    color: "text.secondary",
                                                }}
                                            >
                                                Not Found In This Version
                                            </Box>
                                        </Box>
                                    )
                                }
                            />
                        </Box>
                        <Approved width={22}>
                            <StatusButton
                                onHover={setHover}
                                copied={remove}
                                copy={() => setAdd(!add)}
                                revert={() => setAdd(!add)}
                            />
                            <ListItemText
                                disableTypography
                                sx={{ flex: 1, pl: 3, opacity: remove ? 0.5 : 1 }}
                                primary={
                                    <Box
                                        ref={attach}
                                        sx={{
                                            borderRadius: 1,
                                            transition: "background-color linear 0.2s",
                                            bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                                        }}
                                    >
                                        <Bound editMode={false}>
                                            <Task last={true} item={task} index={0} />
                                        </Bound>
                                    </Box>
                                }
                                secondary={
                                    <Box sx={{ opacity: 0 }}>
                                        {remove
                                            ? `${taskFullLabel(task)} reinstated`
                                            : `${taskFullLabel(task)} removed`}
                                    </Box>
                                }
                                data-cy="task-removed-right-panel"
                            />
                        </Approved>
                    </ListItemBox>
                </DifferenceWrapper>
            </PropertyBox>
        </Bound>
    )
}
